import { FaEquals, FaPlus, FaStethoscope, FaTag } from 'react-icons/fa';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Common/Header/Header';
import PermanenceWrapper from './Permanence';
import TotalsWrapper from './Totals';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Totais',
        path: '/governanceroom/dashboardsihsus/hospitalization/totals',
        icon: <FaPlus className="icon" />
    },
    {
        title: 'Permanência',
        path: '/governanceroom/dashboardsihsus/hospitalization/permanence',
        icon: <FaEquals className="icon" />
    },
    {
        title: 'Caráter de Internação',
        path: '/governanceroom/dashboardsihsus/hospitalization/character-of-admission',
        icon: <FaTag className="icon" />
    },
    {
        title: 'Complexidade',
        path: '/governanceroom/dashboardsihsus/hospitalization/complexity',
        icon: <FaStethoscope />
    }
];

const titleMap = {
    '/governanceroom/dashboardsihsus/hospitalization/totals':
        'Totais - Permanência e Acomodação',
    '/governanceroom/dashboardsihsus/hospitalization/permanence':
        'Média de Dias de Permanência',
    '/governanceroom/dashboardsihsus/hospitalization/character-of-admission':
        'Total de AIH por Caráter de Internação',
    '/governanceroom/dashboardsihsus/hospitalization/complexity':
        'Total de AIH por Complexidade'
};

export const Hospitalization = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="permanence"
                            element={<PermanenceWrapper />}
                        />
                        <Route path="totals" element={<TotalsWrapper />} />

                        <Route
                            path="character-of-admission"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle:
                                            'das AIH por Caráter de Internação'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.CHARACTER_OF_ADMISSSION,
                                        url: 'governanceroom/dashboard/sihsus/aih/hospitalizationTypes'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="complexity"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle:
                                            'das AIH por Complexidade'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.COMPLEXETY_LEVEL,
                                        url: 'governanceroom/dashboard/sihsus/aih/hospitalizationComplexity'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />
                        <Route
                            path="/"
                            element={<Navigate to="totals" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
